import { CallbackInterface } from 'recoil';
import { setSnackbarError, setSnackbarSuccess } from '../common';
import {
  EntityGroup,
  EntityGroupSearchParams,
  GetEntityByType,
  Id,
} from '../types';
import {
  entitiesGroupsState,
  entitiesState,
  entityGroupState,
  entityLoaderState,
} from '../state';
import {
  createEntityGroup,
  deleteEntityGroup,
  getAllEntitiesGroup,
  getEntitiesByType,
  getEntityGroupById,
  patchEntityGroup,
  searchEntityGroup,
} from '../actions/entity';

export const getEntitiesByTypeCallback =
  ({ set }: CallbackInterface) =>
  async (params: GetEntityByType) => {
    set(entityLoaderState, true);
    let res = undefined;
    try {
      res = await getEntitiesByType(params);
      set(entitiesState, res?.data?.items ?? []);
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(entityLoaderState, false);
    return res;
  };

export const getAllEntitiesGroupCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set(entityLoaderState, true);
    let res = undefined;
    try {
      res = await getAllEntitiesGroup();
      set(entitiesGroupsState, res?.data ?? []);
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(entityLoaderState, false);
    return res;
  };

export const getEntityGroupByIdCallback =
  ({ set }: CallbackInterface) =>
  async (params: Id) => {
    set(entityLoaderState, true);
    let res = undefined;
    try {
      res = await getEntityGroupById(params);
      set(entityGroupState, res?.data ?? []);
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(entityLoaderState, false);
    return res;
  };

export const patchEntityGroupCallback =
  ({ set }: CallbackInterface) =>
  async (params: EntityGroup) => {
    set(entityLoaderState, true);
    let res = undefined;
    try {
      res = await patchEntityGroup(params);
      set(entityGroupState, res?.data ?? []);
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(entityLoaderState, false);
    return res;
  };

export const createEntityGroupCallback =
  ({ set }: CallbackInterface) =>
  async (params: EntityGroup) => {
    set(entityLoaderState, true);
    let res = undefined;
    try {
      res = await createEntityGroup(params);
      set(entityGroupState, res?.data ?? []);
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(entityLoaderState, false);
    return res;
  };

export const searchEntityGroupCallback =
  ({ set }: CallbackInterface) =>
  async (params: EntityGroupSearchParams) => {
    set(entityLoaderState, true);
    let res = undefined;
    try {
      res = await searchEntityGroup(params);
      set(entitiesGroupsState, res?.data?.items ?? []);
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(entityLoaderState, false);
    return res;
  };

export const deleteEntityGroupCallback =
  ({ set }: CallbackInterface) =>
  async (params: Id) => {
    set(entityLoaderState, true);
    let res = undefined;
    try {
      res = await deleteEntityGroup(params);
      if (res && res.data)
        setSnackbarSuccess(
          set,
          'Gruppo di entità cancellato con sucesso',
          res.status,
        );
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(entityLoaderState, false);
    return res;
  };
